import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getCurrentUserOffset } from '../../store/AppState/selector'
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron-left.svg'
import { shapePaginator } from '../../resources/typeDefs'
import { updateOffset } from '../../store/AppState/actions'
import { setCurrentPaginationPage } from '../../store/AppState/actions'

const Pagination = ({ offSet, paginator, updateOffsetAction, activateLoadings, handlePersistPaginationPage, currentPersistedPaginationPage }) => {
  const { start, end, count, previousPage, nextPage, updateOffset, page, goToPage } = paginator
  const isNextPageNotExists = paginator.count === paginator.endIndex
  const isPrevPageNotExist = paginator.start === 1

  useEffect(() => {
    updateOffset(offSet)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offSet])

  useEffect(() => {
    goToPage(currentPersistedPaginationPage, offSet)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOnChange = () => (event) => {
    goToPage(0, event.target.value)
    handlePersistPaginationPage(0)
    updateOffsetAction(parseInt(event.target.value))
    activateLoadings()
  }

  const handleNextPage = () => {
    handlePersistPaginationPage(page + 1)
    activateLoadings()
    nextPage()
  }

  const handlePreviousPage = () => {
    handlePersistPaginationPage(page - 1)
    activateLoadings()
    previousPage()
  }

  return (
    <div className="pagination-wrapper">
      <div className="offset-controller">
        <label htmlFor="offset">Rows per page:</label>
        <select name="offset" id="offset" value={offSet} onChange={handleOnChange()}>
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
      <div className="page-controller">
        <span className="info">{start} - {end} of {count}</span>
        <button className="left" disabled={isPrevPageNotExist} onClick={handlePreviousPage}>
          <ChevronIcon />
        </button>
        <button className="right" disabled={isNextPageNotExists} onClick={handleNextPage}>
          <ChevronIcon />
        </button>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  offSet: getCurrentUserOffset(state),
})

const mapDispatchToProps = {
  updateOffsetAction: updateOffset,
  setCurrentPaginationPage,
}

Pagination.defaultProps = {
  activateLoadings: () => {},
  handlePersistPaginationPage: () => {},
}

Pagination.propTypes = {
  offset: PropTypes.number,
  paginator: shapePaginator,
  updateOffsetAction: PropTypes.func,
  handlePersistPaginationPage: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(Pagination)
